/**
 * Checks if a given value is undefined.
 *
 * @param value - The value to check.
 * @returns True if the value is undefined, otherwise false.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isUndefined = (value: any): value is undefined =>
    typeof value === "undefined";

/**
 * Checks if a value is not `undefined`.
 *
 * This utility function is a type guard that determines whether the provided value
 * is not `undefined`. It returns `true` if the value is not `undefined`, and `false` otherwise.
 *
 * @template T - The type of the value to check.
 * @param value - The value to check.
 * @returns A boolean indicating whether the value is not `undefined`.
 */
const isNotUndefined = <T>(value: T): value is Exclude<T, undefined> =>
    !isUndefined(value);

export { isNotUndefined, isUndefined };
